module.exports = __webpack_public_path__ + "static/media/football-icon.def54ec1.svg";